import React, { Fragment, useState, useEffect } from 'react';
import { CDataTable } from '@coreui/react';
import SpinnerWithContainer from '../components/SpinnerWithContainer';
import UsersService from '../services/users.service';

const fields = [
  { key: '_id', label: 'ID' },
  { key: 'firstName', label: 'Name' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },

  // {
  //     key: "options",
  //     label: "Options",
  //     sorter: false,
  //     filter: false,
  // },
];

const Users = () => {
  // component state
  const [isloading, setIsloading] = useState({
    get: false,
    delete: false,
    add: false,
  });
  const [users, setUsers] = useState([]);

  // useEffect to fetch users
  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    setIsloading({ ...isloading, get: true });
    try {
      const res = await UsersService.get();
      setUsers(res.data);
      setIsloading({ ...isloading, get: false });
    } catch (e) {
      setIsloading({ ...isloading, get: false });
      console.log('er', e);
    }
  };

  return (
    <Fragment>
      <h1>Users</h1>

      <Fragment>
        {isloading.get ? (
          <SpinnerWithContainer />
        ) : (
          <CDataTable
            items={users}
            itemsPerPage={2}
            fields={fields}
            tableFilter
            responsive
            // scopedSlots={{
            //     options: (item, index) => {

            //     },

            // }}
          />
        )}
      </Fragment>
    </Fragment>
  );
};

export default Users;
